import { MODULE, ACTION } from '@/utils/constants';
import { mixin, errorMsg } from '@/utils/mixins';
import { getController, postController } from '@/controllers/request';

export default {
  namespaced: true,
  state: {
    metadata: {},
    dublicatesListData: [],
    currentCandidateDublicate: null,
    vacancyListData: [],
    resumeListData: [],
    saveCompare: null,
    requestSent: false,
    loading: false,
    loadingData: false
  },
  mixins: [mixin, errorMsg],

  mutations: {
    clear(state) {
      state.currentCandidateDublicate = null;
      state.vacancyListData = [];
      state.resumeListData = [];
      state.saveCompare = null;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setLoadingData(state, value) {
      state.loadingData = value;
    },
    setMetadata(state, metadata) {
      state.metadata = metadata;
    },
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    }
  },
  actions: {
    async fetchDublicatesByParent({ commit, state }, id) {
      if (!state.requestSent) {
        try {
          commit('setParam', {
            name: 'requestSent',
            val: true
          });
          //если запрос не отвечает дольше, чем 300 мс, то запускается лоадер
          const loaderTimeout = setTimeout(() => {
            if (!response?.data) {
              commit('setLoading', true);
              //если данных нет, ожидаем их получения каждые 500 мс
              //если они получены, отключаем роутер
              const checkData = setInterval(() => {
                if (response?.data) {
                  commit('setLoading', false);
                  clearInterval(checkData);
                }
              }, 500);
            }
            clearTimeout(loaderTimeout);
          }, 300);
          const response = await getController({
            params: {
              module: MODULE.HRPAC_CANDIDATES_DUPLICATES,
              action: 'getCandidateDuplicates',
              candidate_id: id
            }
          });
          commit('setParam', {
            name: 'requestSent',
            val: false
          });
          commit('setParam', {
            name: 'dublicatesListData',
            val: response?.data || []
          });

          if (response?.data?.bean?.id.value || Array.isArray(response?.data)) {
            return true;
          } else {
            if (response?.data?.status == 'error') {
              errorMsg.methods.showNotification({
                offset: 100,
                showClose: true,
                message: response.data?.error?.error_text?.error || 'Ошибка',
                duration: 6500,
                type: 'error'
              });
            }
            return false;
          }
        } catch (e) {
          console.error(e);
        } finally {
          commit('setLoading', false);
        }
      }
    },
    async fetchDublicate({ commit, state }, id) {
      if (!state.requestSent) {
        try {
          commit('setParam', {
            name: 'requestSent',
            val: true
          });
          commit('setParam', { name: 'currentCandidateDublicate', val: null });
          //если запрос не отвечает дольше, чем 300 мс, то запускается лоадер
          const loaderTimeout = setTimeout(() => {
            if (!response?.data) {
              commit('setLoading', true);

              //если данных нет, ожидаем их получения каждые 500 мс
              //если они получены, отключаем роутер
              const checkData = setInterval(() => {
                if (response?.data) {
                  commit('setLoading', false);
                  clearInterval(checkData);
                }
              }, 500);
            }
            clearTimeout(loaderTimeout);
          }, 300);
          const response = await getController({
            params: {
              module: MODULE.CANDIDATES_MODULE,
              action: 'getCandidateView',
              record: id
            }
          });
          commit('setParam', {
            name: 'requestSent',
            val: false
          });
          commit('setParam', {
            name: 'currentCandidateDublicate',
            val: response.data
          });

          if (response.data?.bean?.id.value) {
            return true;
          } else {
            if (response.data?.status == 'error') {
              errorMsg.methods.showNotification({
                offset: 100,
                showClose: true,
                message: response.data?.error?.error_text?.error || 'Ошибка',
                duration: 6500,
                type: 'error'
              });
            }
            return false;
          }
        } catch (e) {
          console.error(e);
        } finally {
          commit('setLoading', false);
        }
      }
    },
    async loadDublicates({ commit, rootState }) {
      let filters = {};
      let currentFilters = rootState.filters.filterConfig.filters;
      let dataSortParams = rootState.filters.filterConfig.sortable;

      for (let key in currentFilters) {
        if (currentFilters[key].value != null) {
          filters[key] = currentFilters[key].value;
        }
      }

      const params = {
        module: MODULE.HRPAC_CANDIDATES_DUPLICATES,
        displayMode: 'spa',
        action: ACTION.LIST_VIEW,
        HRPAC_CANDIDATES_DUPLICATES2_HRPAC_CANDIDATES_DUPLICATES_offset: 0,
        ...filters
      };

      if (rootState.filters.query) {
        params.query = true;
        commit(
          'filters/setParam',
          {
            name: 'query',
            val: false
          },
          { root: true }
        );
      }

      if (dataSortParams?.orderBy) {
        params['orderBy'] = dataSortParams.orderBy;
      }
      if (dataSortParams?.sortOrder) {
        params['sortOrder'] = dataSortParams.sortOrder;
      }

      const request = await getController({ params });
      if (request.data?.error) {
        commit('setMetadata', request.data);
        return;
      }

      const tableData = request.data?.data?.data?.data;
      const pageData = request.data?.data?.pageData;
      const sugarconfig = request.data?.sugarconfig;
      const customSearch = request.data?.custom_search;

      commit(
        'common/setTableData',
        {
          module: MODULE.HRPAC_CANDIDATES_DUPLICATES,
          columns: tableData?.title,
          rows: tableData?.rows
        },
        { root: true }
      );

      commit('selectionPopup/setMetadataFields', sugarconfig, {
        root: true
      });

      commit(
        'common/setParam',
        {
          name: 'tableFields',
          val: sugarconfig
        },
        {
          root: true
        }
      );

      commit('selectionPopup/popupPageConfig', pageData, {
        root: true
      });

      commit('filters/setFiltersConfig', customSearch, {
        root: true
      });

      commit(
        'filters/setParam',
        {
          name: 'sortActive',
          val: !customSearch?.sortable?.default || false
        },
        { root: true }
      );

      commit('setMetadata', request.data);

      if (tableData?.title_params) {
        commit('setParam', {
          name: 'tableTitleParams',
          val: tableData?.title_params
        });
      }
    },
    async fetchVacancy({ commit, state }, id) {
      if (!state.requestSent) {
        try {
          commit('setParam', {
            name: 'requestSent',
            val: true
          });
          commit('setParam', { name: 'vacancyListData', val: [] });
          //если запрос не отвечает дольше, чем 300 мс, то запускается лоадер
          const loaderTimeout = setTimeout(() => {
            if (!response?.data) {
              commit('setLoading', true);
              //если данных нет, ожидаем их получения каждые 500 мс
              //если они получены, отключаем роутер
              const checkData = setInterval(() => {
                if (response?.data) {
                  commit('setLoading', false);
                  clearInterval(checkData);
                }
              }, 500);
            }
            clearTimeout(loaderTimeout);
          }, 300);
          const response = await getController({
            params: {
              module: MODULE.CANDIDATES_MODULE,
              action: 'getCandidateVacancyList',
              record: id
            }
          });
          commit('setParam', {
            name: 'requestSent',
            val: false
          });
          commit('setParam', {
            name: 'vacancyListData',
            val: response.data
          });

          if (response.data?.bean?.id.value) {
            return true;
          } else {
            if (response.data?.status == 'error') {
              errorMsg.methods.showNotification({
                offset: 100,
                showClose: true,
                message: response.data?.error?.error_text?.error || 'Ошибка',
                duration: 6500,
                type: 'error'
              });
            }
            return false;
          }
        } catch (e) {
          console.error(e);
        } finally {
          commit('setLoading', false);
        }
      }
    },
    async fetchResume({ commit, state }, id) {
      if (!state.requestSent) {
        try {
          commit('setParam', {
            name: 'requestSent',
            val: true
          });
          //если запрос не отвечает дольше, чем 300 мс, то запускается лоадер
          const loaderTimeout = setTimeout(() => {
            if (!response?.data) {
              commit('setLoading', true);
              //если данных нет, ожидаем их получения каждые 500 мс
              //если они получены, отключаем роутер
              const checkData = setInterval(() => {
                if (response?.data) {
                  commit('setLoading', false);
                  clearInterval(checkData);
                }
              }, 500);
            }
            clearTimeout(loaderTimeout);
          }, 300);
          const options = new FormData();
          options.append('module', MODULE.HRPAC_CANDIDATES_RESUME);
          options.append('action', 'getResumeDetailView');
          options.append('record', id);

          const response = await postController({ options });
          commit('setParam', {
            name: 'requestSent',
            val: false
          });
          commit('setParam', {
            name: 'resumeListData',
            val: [...state.resumeListData, response.data]
          });

          if (response.data?.bean?.id.value) {
            return true;
          } else {
            if (response.data?.status == 'error') {
              errorMsg.methods.showNotification({
                offset: 100,
                showClose: true,
                message: response.data?.error?.error_text?.error || 'Ошибка',
                duration: 6500,
                type: 'error'
              });
            }
            return false;
          }
        } catch (e) {
          console.error(e);
        } finally {
          commit('setLoading', false);
        }
      }
    },
    async fetchResumes({ dispatch, commit, state }, id) {
      if (!state.requestSent) {
        try {
          commit('setParam', {
            name: 'requestSent',
            val: true
          });
          commit('setParam', { name: 'resumeListData', val: [] });
          //если запрос не отвечает дольше, чем 300 мс, то запускается лоадер
          const loaderTimeout = setTimeout(() => {
            if (!response?.data) {
              commit('setLoading', true);
              //если данных нет, ожидаем их получения каждые 500 мс
              //если они получены, отключаем роутер
              const checkData = setInterval(() => {
                if (response?.data) {
                  commit('setLoading', false);
                  clearInterval(checkData);
                }
              }, 500);
            }
            clearTimeout(loaderTimeout);
          }, 300);
          if (!id) return;

          const options = new FormData();
          options.append('module', MODULE.HRPAC_CANDIDATES_RESUME);
          options.append('action', 'getCandidatesResumeDetailSubpanelData');
          options.append('record', id);

          const response = await postController({ options });
          commit('setParam', {
            name: 'requestSent',
            val: false
          });
          response.data?.metadata?.subpanels?.panelColumn?.forEach(panel =>
            dispatch('fetchResume', panel.id)
          );

          if (response.data?.bean?.id.value) {
            return true;
          } else {
            if (response.data?.status == 'error') {
              errorMsg.methods.showNotification({
                offset: 100,
                showClose: true,
                message: response.data?.error?.error_text?.error || 'Ошибка',
                duration: 6500,
                type: 'error'
              });
            }
            return false;
          }
        } catch (e) {
          console.error(e);
        } finally {
          commit('setLoading', false);
        }
      }
    },
    async fetchDublicateData({ dispatch, commit }, id) {
      commit('setLoadingData', true);
      await dispatch('fetchDublicate', id);
      await dispatch('fetchVacancy', id);
      await dispatch('fetchResumes', id);
      commit('setLoadingData', false);
    }
  }
};
